import { Box, Button } from "@mui/material";
import { Bug } from "lucide-react";
import { useState } from "react";
import AgentDebugTool from "./AgentDebugTool";

export default ({ threadRef }: { threadRef: string }) => {
  const [debugDialogOpen, setDebugDialogOpen] = useState(false);
  return (
    <Box>
      <Button
        variant="text"
        sx={{ height: "unset" }}
        startIcon={<Bug size={16} />}
        onClick={() => setDebugDialogOpen(true)}
      >
        Debug
      </Button>
      <AgentDebugTool
        threadRef={threadRef}
        open={debugDialogOpen}
        onClose={() => setDebugDialogOpen(false)}
      />
    </Box>
  );
};
